import { render, staticRenderFns } from "./AuthoriseSublet.vue?vue&type=template&id=0bf74ea4&scoped=true"
import script from "./AuthoriseSublet.vue?vue&type=script&lang=js"
export * from "./AuthoriseSublet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf74ea4",
  null
  
)

export default component.exports